import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [DBMS - 저장쿼리] 저장쿼리문 list를 조회한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getDbmsQueryinfoList(params) {
    return axios.post(`${baseUrl}/settings/database-saved-query/get-dbms-query-info.do`, params);
  },
  /**
   * [DBMS - 저장쿼리] 저장쿼리문 list를 추가한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  insertDbmsQueryInfo(params) {
    return axios.post(`${baseUrl}/settings/database-saved-query/insert-dbms-query-info.do`, params);
  },
  /**
   * [DBMS - 저장쿼리] 저장쿼리문 list를 수정한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  updateDbmsQueryInfo(params) {
    return axios.post(`${baseUrl}/settings/database-saved-query/update-dbms-query-info.do`, params);
  },
  /**
   * [DBMS - 저장쿼리] 저장쿼리문 list를 삭제한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  deleteDbmsQueryInfo(params) {
    return axios.post(`${baseUrl}/settings/database-saved-query/delete-dbms-query-info-list.do`, params);
  },
  /**
   * [DBMS - 저장쿼리] 저장쿼리문 - 중복된 아이디를 검사한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  validateForRscId(params) {
    return axios.post(`${baseUrl}/settings/database-saved-query/check-dbms-query-info-rsc-id.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/dbms-saved-query.js